<div class="row pt-3">
  <div class="col-12">
    <div class="">
      <div class="">
        <form [formGroup]="formGroup" class="mb-3 mx-2">
          <div class="row g-2 align-items-center">
            <div class="px-2 col-auto d-flex align-items-center gap-3">
              <h5 class="font-16 px-2 py-1">{{ 'attendance.monitoring.liveMonitoring' | translate }}</h5>
              <span
                class="badge rounded-pill bg-primary font-16 px-2 py-1"
                [matTooltip]="'attendance.monitoring.totalOpenAttendances' | translate"
              >
                <i class="ri-message-3-line me-1"></i>
                {{ totalOpen }}
                {{ totalOpen === 1 ? "Atendimento" : "Atendimentos" }}
              </span>
              <span
                class="badge rounded-pill font-16 px-2 py-1 bg-danger bg-opacity-10 text-danger"
                [class.pulse-animation]="totalDelayed > 0"
              >
                <i class="mdi mdi-alert-outline me-1"></i>
                {{ totalDelayed }} {{ 'attendance.monitoring.delayed' | translate }}
              </span>
            </div>
            <div class="col"></div>

            <div class="col-auto d-flex align-items-center gap-2">
              <span class="text-muted fw-bold font-14">{{ 'attendance.monitoring.viewBy' | translate }}</span>
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="btn"
                  [ngClass]="viewMode === 'user' ? 'btn-primary' : 'btn-light'"
                  (click)="setViewMode('user')"
                >
                  <i class="ri-group-line me-1"></i> {{ 'attendance.monitoring.user' | translate }}
                </button>
                <button
                  type="button"
                  class="btn"
                  [ngClass]="
                    viewMode === 'department' ? 'btn-primary' : 'btn-light'
                  "
                  (click)="setViewMode('department')"
                >
                  <i class="ri-building-line me-1"></i> {{ 'attendance.monitoring.department' | translate }}
                </button>
              </div>
            </div>

            <!-- Filtro de canal -->
            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                  <button mat-menu-item (click)="searchByChannel(null)">
                    {{ 'attendance.monitoring.all' | translate }}
                  </button>
                  @for (channel of listChannel; track channel._id) {
                    <button mat-menu-item (click)="searchByChannel(channel)">
                      {{ channel.name }}
                    </button>
                  }
                } @else {
                  <h6 class="text-muted m-1">{{ 'attendance.monitoring.noResultsFound' | translate }}</h6>
                }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-1 btn-group trend-button"
            >
              <button
                type="button"
                class="btn btn-primary fw-bold"
                (click)="openSettingsDialog()"
              >
                <i class="ri-settings-3-line"></i>
              </button>
            </div>
          </div>
        </form>

        <hr />

        @if (loadingContent) {
          <content-loading-list />
        } @else {
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <div class="p-0">
                  <div class="kanban-board scroll">
                    @for (column of statusColumns; track column.key) {
                      <app-attendance-monitoring-column
                        [column]="column"
                        [channelFilter]="channelFilter"
                        [reloadTrigger]="reloadTrigger"
                        [tickTrigger]="tickTrigger"
                        [delayThresholdSeconds]="effectiveThresholdSeconds"
                      />
                    }

                    @for (column of groupColumns; track column.key) {
                      <app-attendance-monitoring-column
                        [column]="column"
                        [channelFilter]="channelFilter"
                        [reloadTrigger]="reloadTrigger"
                        [tickTrigger]="tickTrigger"
                        [delayThresholdSeconds]="effectiveThresholdSeconds"
                      />
                    }

                    @if (totalOpen === 0 && groupColumns.length === 0) {
                      <div
                        class="d-flex flex-column align-items-center justify-content-center w-100 py-5 text-muted"
                      >
                        <i class="ri-inbox-line font-48 opacity-50 mb-2"></i>
                        <p class="mb-0 font-14">
                          {{ 'attendance.monitoring.noAttendancesAtTheMoment' | translate }}
                        </p>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
